import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Router } from 'react-router-dom';
import axios from 'axios';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store';
import { NotificationsProvider } from './providers/notificationsProvider';
import history from './util/history';
import { setDataToLocalStorage } from './localStorage/setDataToLocalStorage';
import { LocalStorageKey } from './localStorage/enums/localStorageKey.enum';
import { LOGOUT_SUCCESS } from './constant/actionType';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  }
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { pathname } = window.location;

    if (error?.request?.status === 401 && pathname !== '/login') {
      setDataToLocalStorage(LocalStorageKey.SESSION_ID, '');
      store.dispatch({ data: {}, type: LOGOUT_SUCCESS });
      store.clear();
      history.push('/login');
    }

    throw error;
  }
);

const app = (
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <NotificationsProvider>
        <Router history={history}>
          <App />
        </Router>
      </NotificationsProvider>
    </Provider>
  </QueryClientProvider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
